import actions from '@/core/store/item-ata/bloqueio/bloquear/actions'
import state from '@/core/store/item-ata/bloqueio/bloquear/state'
import mutations from '@/core/store/item-ata/bloqueio/bloquear/mutations'

export default { actions, state, mutations }
